import { staffTypes } from "../../types/userTypes";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Inject,
  Optional,
  OnInit
} from "@angular/core";
import {
  UntypedFormGroup,
  FormControl,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators,
  AbstractControl,
  ValidationErrors
} from "@angular/forms";
import { CoreService } from "../../services/coreService";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

declare let toastr: any;

@Component({
    selector: "make-staff-modal",
    templateUrl: "./make-staff-modal.component.html",
    styleUrls: ["./make-staff-modal.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class MakeStaffModalComponent implements OnChanges, OnInit {
  staffs: any;
  form: UntypedFormGroup;
  isSubmitted = false;
  user_types;
  showSusbcriptions=false;
  susbscription_types;
  @Input() parkingID = null;
  @Output() close = new EventEmitter();
  // @Output() makeStaff = new EventEmitter<any>();
  @Output() makeStaff = new EventEmitter<any>();
  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<MakeStaffModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { parkingID } = this.data;
    this.parkingID = parkingID;
    this.form = this.builder.group({
      parking_place_id: [this.parkingID, Validators.required],
      email_or_mobile: ["", [Validators.required, this.emailOrMobileValidator()]],
      
      user_type: ["", Validators.required],
      
    });
  }
  private emailOrMobileValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const mobilePattern = /^(?:(?:\+|00)\d{12}|\d{7,10})$/;

      const emailValid = emailPattern.test(value);
      const mobileValid = mobilePattern.test(value);

      if (emailValid || mobileValid) {
        return null; // No error
      }

      return { email_or_mobile: true }; // Return an error object
    };
  }
  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.form.setValue({
      parking_place_id: this.parkingID,
      
      email_or_mobile: "",
      
      user_type: "",
      
    });
    this.isSubmitted = false;
  }

  submitForm() {
    console.log(this.form.value);
    this.isSubmitted = true;
    if (this.form.valid) {
      this.makeStaff.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      this.resetModal();
    } else {
      toastr.error("", "Form is invalid.", {
        timeOut: 2000
      });
    }
  }


  async ngOnInit() {
    try {
      this.user_types = await this.coreService
        .GetParkingPlaceRegConfig()
        .then(response => response.user_types);
    } catch (error) {
      toastr.error("", "Failed to fetch user types.", {
        timeOut: 2000
      });
    }
    try {
     this.susbscription_types = await this.coreService
        .GetParkingPlaceSuscription(this.parkingID)
        .then(response => response.data);
    } catch (error) {
      toastr.error("", "Failed to fetch Subscription types.", {
        timeOut: 2000
      });
      this.closeModal();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.parkingID.currentValue != null) {
      this.resetModal();
    }
  }

  userTypeChange()
  {
    if(this.form.value.user_type=='Tenant'){
      this.showSusbcriptions=true;
    }
    else{
      this.showSusbcriptions=false;
    }  
  }
}
